import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { InventoryNotesComponent } from "../inventory-notes/inventory-notes.component";
import { Inventory } from "../Inventory";
import { InventoryService } from "../inventory.service";
import { CommonService } from "src/app/services/common.service";
import { PurchaseOrderModalComponent } from "../purchase-order-modal/purchase-order-modal.component";
import { InventoryDocUploaderComponent } from "../inventory-doc-uploader/inventory-doc-uploader.component";
import { PasswordCheckerComponent } from "../password-checker/password-checker.component";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-purchase-order-list",
  templateUrl: "./purchase-order-list.component.html",
  styleUrls: ["./purchase-order-list.component.sass"],
})
export class PurchaseOrderListComponent implements OnInit, OnDestroy {
  isAuthorized: any;

  routeParams = {
    create_po: {
      title: "New Purchase Order",
      status: "New",
    },
    po_sent: {
      title: "Sent Purchase Order",
      status: "Sent",
    },
    po_received: {
      title: "Received Purchase Order",
      status: "Received",
    },
  };

  status = "";
  title = "";
  items = [];
  totalPages: number;
  totalRecords: number = 0;
  currentPageNo: number = 1;
  selectedInventoryId = "";
  loader = false;
  modalSubscription: Subscription;
  modalRef: BsModalRef;
  routeSubscription: Subscription;

  constructor(
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private api: InventoryService,
    private commonService: CommonService,
    private router: Router
  ) { }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.deleteComponent();
      });

    this.routeSubscription = this.route.params.subscribe((params: Params) => {
      this.status = this.route.snapshot.params.status;
      this.title = this.routeParams[this.status].title;


      this.getInventoryList();
    });
    this.calculateOrderNoRowSpan();

  }

  handleUserAuthCheck(url: any, name: string) {
    this.items = [];
    sessionStorage.setItem("ivu", "false");
    const initialState = {
      component: "inventory",
      url,
      name,
    };
    this.modalRef = this.modalService.show(PasswordCheckerComponent, {
      initialState,
      class: "modal-lg",
    });
    this.modalSubscription = this.modalService.onHide.subscribe(() => {
      this.isAuthorized = sessionStorage.getItem("ivu");

      if (this.isAuthorized == "true") {
        this.loader = true;
        this.getInventoryList();
      } else {
        this.router.navigate(["users/list"]);
      }
    });
  }

  handlePageChange({ page }) {
    this.currentPageNo = page;
    this.getInventoryList();
  }

  getInventoryList(search?: string) {
    if (!this.status) {
      return;
    }
    this.loader = true;
    this.api
      .getPurchaseOrders({
        search,
        status: this.status,
        page: this.currentPageNo,
      })
      .subscribe(
        (result: any) => {
          const response = result.data;
          this.items = response.items;
          this.totalRecords = response.count;
          this.totalPages = response.totalPages;
          this.currentPageNo = response.currentPage;
          this.loader = false;
        },
        (error: any) => {
          this.loader = false;
          this.commonService.toast(error.error.message, "Error");
        }
      );
  }

  handleSearch(event: Event) {
    const inputElement = event.target as HTMLInputElement;

    this.getInventoryList(inputElement.value);
  }

  handleInventoryNotesModel(inventoryId: string) {
    const initialState = {
      inventoryId,
      showAddAndDeleteBtn: false,
      noteType: "purchase_order",
    };
    this.modalService.show(InventoryNotesComponent, {
      initialState,
      class: "modal-lg",
    });
    this.modalService.onHide.subscribe(() => {
      this.getInventoryList();
    });
  }

  handleShowOrderModal(productItem: any, j: any) {

    // const modalData = {
    //   _id: productItem._id,
    //   inventory: productItem.inventory,
    //   orderNo: productItem.orderNo || '',
    //   name: productItem.name || '',
    //   createdAt: productItem.createdAt,
    //   deliveryPickupAddress: productItem.deliveryPickupAddress,
    //   category: productItem.purchaseItems[j],
    //   note: productItem.inventoriesNote.length > 0 ? productItem.inventoriesNote : []
    // };

    const initialState = {
      item: productItem,
    };

    this.modalService.show(PurchaseOrderModalComponent, {
      initialState,
      class: "modal-lg",
    });

    this.modalService.onHide.subscribe(() => { });
  }

  // handleShowOrderModal(orderItem: any,j:any) {

  //   const modalData = {
  //   inventory: orderItem.inventory, 
  //   orderNo: orderItem.orderNo || '', 
  //     name: orderItem.name || '', 
  //     createdAt: orderItem.createdAt,
  //     deliveryPickupAddress:orderItem.deliveryPickupAddress,
  //   category:orderItem.orderItems[j]
  // };
  // const initialState = {
  //   item: modalData
  // };
  //   this.modalService.show(InternalOrderModalComponent, {
  //     initialState,
  //     class: "modal-lg",
  //   });

  //   this.modalService.onHide.subscribe(() => {});
  // }


  handleDocUpload(orderId: string, images: string[]) {
    const initialState = {
      orderId,
      images,
    };
    this.modalService.show(InventoryDocUploaderComponent, {
      initialState,
      class: "modal-lg",
    });
    this.modalService.onHide.subscribe(() => {
      this.getInventoryList();
    });
  }

  setSelectedInventoryId(id: string) {
    this.selectedInventoryId = id;
  }

  deltedata() {
    const Id = this.selectedInventoryId;
    this.api.deletePurchaseOrder(Id).subscribe(
      (result: any) => {
        this.loader = false;
        if (result.success === true) {
          this.commonService.toast(result.message, "Success");
        } else {
          this.commonService.toast(result.message, "Error");
        }

        this.getInventoryList();
      },
      (error: any) => {
        this.loader = false;
        this.commonService.toast(error.error.message, "Error");
      }
    );
  }

  handleUpdateStatus(orderId: string, event) {
    const status = event.target.value;

    this.api.updatePurchaseOrderStatus(orderId, { status }).subscribe(
      (result: any) => {
        this.loader = false;
        if (result.success === true) {
          this.commonService.toast(result.message, "Success");
        } else {
          this.commonService.toast(result.message, "Error");
        }

        this.getInventoryList();
      },
      (error: any) => {
        this.loader = false;
        this.commonService.toast(error.error.message, "Error");
      }
    );
  }

  ngOnDestroy() {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
    if (this.modalRef) {
      this.modalRef.hide();
      this.modalRef = null;
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    this.items = [];
    this.totalPages = 0;
    this.totalRecords = 0;
    this.currentPageNo = 1;
    this.selectedInventoryId = "";
    this.loader = false;
    this.isAuthorized = null;
    this.status = "";
    this.title = "";
  }

  deleteComponent() {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
    if (this.modalRef) {
      this.modalRef.hide();
      this.modalRef = null;
    }
  }
  orderNoRowSpanMap: { [key: string]: number } = {};



  calculateOrderNoRowSpan() {
    this.orderNoRowSpanMap = {};
    this.items.forEach(item => {
      const orderNo = item.orderNo;
      if (!this.orderNoRowSpanMap[orderNo]) {
        this.orderNoRowSpanMap[orderNo] = item.purchaseItems.length;
      }
    });
  }

}